// Central business info for Good Choice Cleaning & Multi Services
export const SITE = {
  name: "Good Choice Cleaning & Multi Services",
  shortName: "Good Choice Cleaning",
  owner: "Frankely Santos",
  phoneDisplay: "(540) 560-4862",
  phoneHref: "tel:+15405604862",
  email: "fgoodchoice@gmail.com",
  emailHref: "mailto:fgoodchoice@gmail.com",
  domain: "goodchoicecleaningandmultiservices.com",
  url: "https://goodchoicecleaningandmultiservices.com",
  region: "Shenandoah Valley",
  serviceArea: "Harrisonburg & the Shenandoah Valley",
  hoursWeekday: "Mon–Fri: 7:00 AM – 7:00 PM",
  hoursWeekend: "Sat–Sun: 9:00 AM – 5:00 PM",
  referralOffer: "Earn a free regular cleaning for every 2 successful referrals.",
  instagram: "https://www.instagram.com/goodchoicecms",
  facebook: "https://www.facebook.com/GoodChoiceCleaning101/",
  formSrc: "https://link.systemic-digital.net/widget/form/jqck9EXAQq26Jv7lQt7y",
  formId: "jqck9EXAQq26Jv7lQt7y",
} as const;
